import { get } from 'vio-libs';
export function getActivityUsersLogs(filter, organization, logsPerPage, page, status) {
    var _a, _b;
    return get(`user-logs?organization=${organization}&page=${page}&page-size=${logsPerPage}&status=${status}`, {
        params: {
            'function-name': (_a = filter === null || filter === void 0 ? void 0 : filter.functionName) === null || _a === void 0 ? void 0 : _a.value,
            'location': (_b = filter === null || filter === void 0 ? void 0 : filter.location) === null || _b === void 0 ? void 0 : _b.value,
            'start': filter === null || filter === void 0 ? void 0 : filter.startDate,
            'user': filter === null || filter === void 0 ? void 0 : filter.user
        }
    });
}
export function getActivityLocationLogs(location, organization, logsPerPage, page, status) {
    return get(`site-logs?organization=${organization}&location=${location}&page=${page}&page-size=${logsPerPage}&status=${status}`);
}
export function getActivityLocationsLogs(filter, organization, logsPerPage, page, status) {
    var _a, _b;
    return get(`site-logs?organization=${organization}&page=${page}&page-size=${logsPerPage}&status=${status}`, {
        params: {
            'function-name': (_a = filter === null || filter === void 0 ? void 0 : filter.functionName) === null || _a === void 0 ? void 0 : _a.value,
            'location': (_b = filter === null || filter === void 0 ? void 0 : filter.location) === null || _b === void 0 ? void 0 : _b.value,
            'start': filter === null || filter === void 0 ? void 0 : filter.startDate,
            'user': filter === null || filter === void 0 ? void 0 : filter.user
        }
    });
}
export function getActivityKEXLogs(filter, organization, logsPerPage, page, status) {
    var _a, _b;
    return get(`kex-logs?organization=${organization}&page=${page}&page-size=${logsPerPage}&status=${status}`, {
        params: {
            'function-name': (_a = filter === null || filter === void 0 ? void 0 : filter.functionName) === null || _a === void 0 ? void 0 : _a.value,
            'location': (_b = filter === null || filter === void 0 ? void 0 : filter.location) === null || _b === void 0 ? void 0 : _b.value,
            'start': filter === null || filter === void 0 ? void 0 : filter.startDate,
            'user': filter === null || filter === void 0 ? void 0 : filter.user
        }
    });
}
export function getActivityCrossConnectionLogs(filter, organization, logsPerPage, page, status) {
    var _a, _b;
    return get(`cross-connection-logs?organization=${organization}&page=${page}&page-size=${logsPerPage}&status=${status}`, {
        params: {
            'function-name': (_a = filter === null || filter === void 0 ? void 0 : filter.functionName) === null || _a === void 0 ? void 0 : _a.value,
            'location': (_b = filter === null || filter === void 0 ? void 0 : filter.location) === null || _b === void 0 ? void 0 : _b.value,
            'start': filter === null || filter === void 0 ? void 0 : filter.startDate,
            'user': filter === null || filter === void 0 ? void 0 : filter.user
        }
    });
}
export function getActivityNetworkInterfacesLogs(organization, logsPerPage, page, status) {
    return get(`network-interfaces-logs?organization=${organization}&page=${page}&page-size=${logsPerPage}&status=${status}`);
}
export function getActivityLocationNetworkInterfacesLogs(filter, organization, logsPerPage, page, status) {
    var _a, _b;
    return get(`network-interfaces-logs?organization=${organization}&page=${page}&page-size=${logsPerPage}&status=${status}`, {
        params: {
            'function-name': (_a = filter === null || filter === void 0 ? void 0 : filter.functionName) === null || _a === void 0 ? void 0 : _a.value,
            'location': (_b = filter === null || filter === void 0 ? void 0 : filter.location) === null || _b === void 0 ? void 0 : _b.value,
            'start': filter === null || filter === void 0 ? void 0 : filter.startDate,
            'user': filter === null || filter === void 0 ? void 0 : filter.user
        }
    });
}
